// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"888":"91f6ee97","2656":"7ed17f5f","4233":"dab9a7c1","4488":"dab9a7c1"}[chunkId] + ".chunk.css";
};